// extracted by mini-css-extract-plugin
export default {"fixed-header":"header_fixed-header__9R0vA","logo":"header_logo__4GGOL"};